module.exports = __webpack_public_path__ + "assets/images/ert_sports6.e30885f5edd33f2a0a74e15c825ccb14.png";